export enum EntityFeatureCategoryType {
    ORGANIZATIONAL_UNIT = "ou_feature",
    SARCAT = "sarcat_feature",
    INBOX_QUOTA = "inbox_quota_feature",
    INBOX = "inbox_feature",
    PROMOTER = "promoter_feature"
}

export const ENTITY_FEATURE_CATEGORY_TYPE = [
    { id: EntityFeatureCategoryType.ORGANIZATIONAL_UNIT, name: "Unitats organitzatives" },
    { id: EntityFeatureCategoryType.SARCAT, name: "S@RCAT" },
    { id: EntityFeatureCategoryType.INBOX_QUOTA, name: "Bústies Quota" },
    { id: EntityFeatureCategoryType.INBOX, name: "Bústies" },
    { id: EntityFeatureCategoryType.PROMOTER, name: "Prestador" }
]

export const ENTITY_FEATURE_CATEGORY_TYPE_MAP = new Map(
    ENTITY_FEATURE_CATEGORY_TYPE.map(item => [item.id, item.name])
)
